import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Button } from 'primereact/button';
import { Gr8piFormattedDate } from '../../../../../components/Gr8piFormattedDateTime';
import { intlShape } from '../../../../../components/prop-types';


const messages = defineMessages({
  activate: {
    id: 'actions.activate',
    defaultMessage: 'Activate',
  },
});

const getFileStatus = (status) => {
  switch (status) {
    case 'VALID_IMPORT': {
      return (
        <FormattedMessage id="file_import.valid" defaultMessage="Valid">
          {text => <span className="filter filter--info is-active">{text}</span>}
        </FormattedMessage>
      );
    }
    case 'FAILED_IMPORT': {
      return (
        <FormattedMessage id="ile_import.failed" defaultMessage="Failed">
          {text => <span className="filter filter--error is-active">{text}</span>}
        </FormattedMessage>
      );
    }
    case 'ACTIVATED': {
      return (
        <FormattedMessage id="file_import.activated" defaultMessage="Activated">
          {text => <span className="filter filter--success is-active ">{text}</span>}
        </FormattedMessage>
      );
    }
    default: {
      return null;
    }
  }
};

const ImportFileDetailGeneric = (props) => {
  const {
    respondentImport, isLoading, openActiveModal,
    intl: { formatMessage },
  } = props;
  const {
    fileName, status, createdOn, updatedOn,
  } = respondentImport;

  const activeLabelText = formatMessage(messages.activate);

  return (
    <div>
      <h1 className="border-bottom no-margin clearfix">
        {fileName}
        {status === 'VALID_IMPORT' && (
          <Button
            label={activeLabelText}
            disabled={isLoading}
            onClick={openActiveModal}
          />
        )}
      </h1>
      <div className="row super-link-url-wrapper">
        <div className="col-md-2 col-sm-4 col-xs-6">
          <span>
            <FormattedMessage id="attrs.status" defaultMessage="Status" />
          </span>
          :
        </div>
        <div className="col-md-10 col-sm-8 col-xs-6">
          <span>{getFileStatus(status)}</span>
        </div>
      </div>
      <div className="row">
        <div className="col-md-2 col-sm-4 col-xs-6">
          <span>
            <FormattedMessage id="attrs.created.verbose" defaultMessage="Created on" />
          </span>
          :
        </div>
        <div className="col-md-10 col-sm-8 col-xs-6">
          <span>
            <strong>
              <Gr8piFormattedDate dateValue={createdOn} />
            </strong>
          </span>
        </div>
      </div>
      <div className="row">
        <div className="col-md-2 col-sm-4 col-xs-6">
          <FormattedMessage id="attrs.updated.verbose" defaultMessage="Last update on" />
          :
        </div>
        <div className="col-md-10 col-sm-8 col-xs-6">
          <span>
            <strong>
              <Gr8piFormattedDate dateValue={updatedOn} />
            </strong>
          </span>
        </div>
      </div>
    </div>
  );
};

ImportFileDetailGeneric.propTypes = {
  respondentImport: PropTypes.objectOf(PropTypes.any),
  isLoading: PropTypes.bool.isRequired,
  openActiveModal: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

ImportFileDetailGeneric.defaultProps = {
  respondentImport: null,
};

export default injectIntl(ImportFileDetailGeneric);
